import { DiscoveryApi, FetchApi } from '@backstage/core-plugin-api';
import { submitRequest } from './submitRequest';
import { DefaultResponse } from '@mercedes-benz/pmas-common';

export class AkamaiApi {
  private readonly discoveryApi: DiscoveryApi;
  private readonly fetchApi: FetchApi;

  constructor(discoveryApi: DiscoveryApi, fetchApi: FetchApi) {
    this.discoveryApi = discoveryApi;
    this.fetchApi = fetchApi;
  }

  async getAkamaiCpCodes(): Promise<DefaultResponse<any>> {
    return submitRequest({
      discoveryApi: this.discoveryApi,
      fetchApi: this.fetchApi,
      method: 'GET',
      path: `/akamai/cpcodes`,
    });
  }
  async getAkamaiCpCodesPerTenant(
    tenant: string,
  ): Promise<DefaultResponse<any>> {
    return submitRequest({
      discoveryApi: this.discoveryApi,
      fetchApi: this.fetchApi,
      method: 'GET',
      path: `/akamai/cpcodes/${encodeURIComponent(tenant)}`,
    });
  }

  async invalidateCpCodes(
    cpCodeIds: number[],
    network: string = 'staging',
  ): Promise<DefaultResponse<any>> {
    return submitRequest({
      discoveryApi: this.discoveryApi,
      fetchApi: this.fetchApi,
      method: 'POST',
      path: `/akamai/invalidate-cpcodes`,
      body: { cpCodeIds, network },
    });
  }
}
